import React from 'react';
import { GrossOfFeeIcon } from '../../../GrossOfFeeIcon/GrossOfFeeIcon';
import { Stat } from '../../../../../CommonComponents/OPL/Stat/Stat';

interface Props {
  label: string;
  value: string | null;
}

export const PeriodReturnsContent = ({ label, value }: Props) => {
  return (
    <Stat
      label={
        <>
          {label}
          <GrossOfFeeIcon />
        </>
      }
      value={value || '–'}
    />
  );
};
